var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayout3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 112,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 755,
    y: 48,
    width: 125,
    height: 112
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33)",
    transform: "translate(-755 -48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.364 56.0909 334.091 56.0909 334.091 106.818 277.364 106.818Z",
    stroke: "current",
    strokeWidth: 1.25,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    transform: "matrix(1.00806 0 0 1 476.041 -7.45455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.364 56.0909 400.091 56.0909 400.091 106.818 343.364 106.818Z",
    stroke: "current",
    strokeWidth: 1.25,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    transform: "matrix(1.00806 0 0 1 476.041 -7.45455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.364 116.091 400.091 116.091 400.091 166.818 277.364 166.818Z",
    stroke: "current",
    strokeWidth: 1.25,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    transform: "matrix(1.00806 0 0 1 476.041 -7.45455)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout3);
export default __webpack_public_path__ + "static/media/layout3.bc72b144c915cebada92174e17ad7250.svg";
export { ForwardRef as ReactComponent };